import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'sku-add-category-modal--title',
    defaultMessage: 'Add category',
  },
  categoryNameLabel: {
    id: 'sku-add-category-modal--category-name-label',
    defaultMessage: 'Category name',
  },
  categoryNamePlaceholder: {
    id: 'sku-add-category-modal--category-name-placeholder',
    defaultMessage: 'E.g. "Salads"',
  },
  selectMenu: {
    id: 'sku-add-category-modal--select-menu',
    defaultMessage: 'Select menu',
  },
  closeAriaLabel: {
    id: 'sku-add-category-modal--close-aria-label',
    defaultMessage: 'Close',
  },
  required: {
    id: 'sku-add-category-modal--required',
    defaultMessage: 'Required',
  },
  save: {
    id: 'sku-add-category-modal--save',
    defaultMessage: 'Save',
  },
  categoryNameRequired: {
    id: 'sku-add-category-modal--category-name-required',
    defaultMessage: 'Category name is required.',
  },
  categoryCreated: {
    id: 'sku-add-category-modal--category-created',
    defaultMessage: '<strong>{categoryName}</strong> category was successfully added',
  },
  categoryCreateError: {
    id: 'sku-add-category-modal--category-create-error',
    defaultMessage: '<strong>We were unable to add your category</strong>',
  },
});
